// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"92c8b8cb","830":"f6a263b6"}[chunkId] + ".chunk.js";
};